import { request } from 'sonata-react-components';

import type { SharedMapResponse } from '@/components/SharedMap/sharedMap.types';

export type {
  PublicCampaignMapDataPoint,
  PublicLayerConfigDTO,
  PublicLayerDTO,
  PublicMapDataPointDTO,
  SharedCampaignMapResponse,
  SharedLayerMapResponse,
  SharedMapResponse
} from '@/components/SharedMap/sharedMap.types';

export async function fetchSharedMap(token: string): Promise<SharedMapResponse> {
  return request.makeRequest(`${taptap.config.backendUrlBase}sharedMap`, {
    data: { token },
    headers: { 'Content-Type': 'application/json' },
    method: 'POST'
  });
}
